import { Link } from "@tanstack/react-router"

import type { MarketPeerCompany } from "@/db/queries/market"
import { formatRankDisplay } from "@/helpers/market/format-rank-display"

export function TopInstallerCard({
  company,
  poolSize,
}: {
  company: MarketPeerCompany
  poolSize: number
}) {
  const rankDisplay =
    company.absoluteRank == null
      ? null
      : formatRankDisplay(company.absoluteRank, poolSize, company.trustScore)

  return (
    <Link to="/company/$longSlug" params={{ longSlug: company.longSlug }}>
      <div className="border-border bg-background flex items-stretch border shadow-sm transition-all hover:shadow-md active:translate-x-[2px] active:translate-y-[2px] active:shadow-none">
        <div className="flex flex-1 flex-col justify-center p-4 md:p-6">
          <h3 className="text-lg font-bold">{company.name}</h3>
          <div className="text-muted-foreground mt-1 text-sm">
            {rankDisplay && (
              <span className="mr-3 font-mono">{rankDisplay}</span>
            )}
            {company.reviewCount != null && (
              <span>{company.reviewCount.toLocaleString()} reviews</span>
            )}
          </div>
        </div>
        <div className="brand-light flex w-[120px] shrink-0 flex-col items-center justify-center p-4">
          <span className="wb-label border-b-2 pb-1 font-bold">
            Trust Score
          </span>
          <div className="mt-2 text-4xl font-bold tracking-tighter">
            {company.trustScore}
          </div>
        </div>
      </div>
    </Link>
  )
}
